<div class="mainContent">
    <div style="height: 7vh;">
      <div>
        <label i18n="@@spmsUserReg" title="Select Services" class="textColour" [ngStyle]="{'border-color': backgroundColorButton}">
          Select Services
          <mat-icon 
            *ngIf="tooltipMessage" 
            [matTooltip]="tooltipMessage" 
            class="info-icon">
            info
          </mat-icon>
        </label>
        <span class="example-spacer"></span>
      </div>
    </div>
  
    <div style="height: 55vh; overflow: auto; padding-left: 4%; padding-right: 4%;">
      <form novalidate [formGroup]="FormValid" style="width: 100%;">
        <div class="row" style="margin-top: 10px;">
          <div class="col-lg">
            <mat-form-field appearance="outline" style="margin-bottom: 5px; height: 35px;">
              <mat-label>Extraction</mat-label>
              <input
            
                matInput
                type="number"
                formControlName="extraction"
                [(ngModel)]="runningService.extraction"
                required
              />
            </mat-form-field>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('extraction').hasError('required') && (FormValid.get('extraction').dirty || FormValid.get('extraction').touched)">
              Extraction is required.
            </mat-error>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('extraction').hasError('pattern') && FormValid.get('extraction').dirty">
              Extraction must be a positive integer.
            </mat-error>
            
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-lg">
            <mat-form-field appearance="outline" style="margin-bottom: 5px; height: 35px;">
              <mat-label>Transform</mat-label>
              <input
                matInput
                type="number"
                formControlName="transform"
                [(ngModel)]="runningService.transform"
                required
              />
            </mat-form-field>
            
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('transform').hasError('required') && (FormValid.get('transform').dirty || FormValid.get('transform').touched)">
              Transform is required.
            </mat-error>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('transform').hasError('pattern') && FormValid.get('transform').dirty">
              Transform must be a positive integer.
            </mat-error>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-lg">
            <mat-form-field appearance="outline" style="margin-bottom: 5px; height: 35px;">
              <mat-label>Validation</mat-label>
              <input
                matInput
                type="number"
                formControlName="validation"
                [(ngModel)]="runningService.validation"
                required
              />
            </mat-form-field>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('validation').hasError('required') && (FormValid.get('validation').dirty || FormValid.get('validation').touched)">
              Validation is required.
            </mat-error>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('validation').hasError('pattern') && FormValid.get('validation').dirty">
              Validation must be a positive integer.
            </mat-error>
          </div>
        </div>
        
        
        <div class="row" style="margin-top: 20px;">
          <div class="col-lg">
            <mat-form-field appearance="outline" style="margin-bottom: 5px; height: 35px;">
              <mat-label>Load</mat-label>
              <input
                matInput
                type="number"
                formControlName="loader"
                [(ngModel)]="runningService.loader"
                required
              />
            </mat-form-field>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('loader').hasError('required') && (FormValid.get('loader').dirty || FormValid.get('load').touched)">
              Load is required.
            </mat-error>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('loader').hasError('pattern') && FormValid.get('loader').dirty">
              Load must be a positive integer.
            </mat-error>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-lg">
            <mat-form-field appearance="outline"style="margin-bottom: 5px; height: 35px;">
              <mat-label>Load To FTP</mat-label>
              <input
                matInput
                type="number"
                formControlName="loadtoftp"
                [(ngModel)]="runningService.loadtoftp"
                required
              />
            </mat-form-field>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('loadtoftp').hasError('required') && (FormValid.get('loadtoftp').dirty || FormValid.get('loadToFTP').touched)">
              Load To FTP is required.
            </mat-error>
            <mat-error style="font-size: 10px ; margin-left: 5px;" *ngIf="FormValid.get('loadtoftp').hasError('pattern') && FormValid.get('loadtoftp').dirty">
              Load To FTP must be a positive integer.
            </mat-error>
          </div>
        </div>
      </form>
    </div>
    
    <div style="height: 1vh">
    <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%;margin-bottom: 0px;">
        <div class="col-lg text-center">
          <div style="text-align: end;">
            <button
              i18n="@@TargetClear"
              type="button"
              title="Save"
              (click)="updateData()"
              class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              style="padding: .3rem 1.6rem; font-size: .85rem; width: 95px; color: white;"
            >
              {{ buttonName }}
            </button>
            <button
              i18n="@@TargetCancel"
              type="button"
              title="Cancel"
              (click)="close()"
              class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              style="padding: .3rem 1.6rem; font-size: .85rem; width: 95px; color: white;"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
      
  </div>
  